"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.usersReducer = exports.initialChangePasswordState = exports.initialUpdateUserState = exports.initialCreateUserState = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _actions = require("./actions");

var _constants = require("./constants");

var _constants2 = require("../constants");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var CREATE_USER = _constants.USER_STATE_KEYS.CREATE_USER,
    UPDATE_USER = _constants.USER_STATE_KEYS.UPDATE_USER,
    CHANGE_PASSWORD = _constants.USER_STATE_KEYS.CHANGE_PASSWORD,
    VIEW_USER = _constants.USER_STATE_KEYS.VIEW_USER,
    LIST = _constants.USER_STATE_KEYS.LIST;
var initialUserState = {
  email: '',
  name: '',
  phoneNumber: '',
  roles: [],
  lockoutEnd: null,
  authenticationProviders: []
};
var initialPasswordState = {
  password: '',
  confirmPassword: ''
};

var initialCreateUserState = _objectSpread(_objectSpread({}, initialUserState), initialPasswordState);

exports.initialCreateUserState = initialCreateUserState;

var initialUpdateUserState = _objectSpread({
  id: null
}, initialUserState);

exports.initialUpdateUserState = initialUpdateUserState;

var initialChangePasswordState = _objectSpread(_objectSpread({
  id: null
}, initialPasswordState), {}, {
  oldPassword: ''
});

exports.initialChangePasswordState = initialChangePasswordState;

var getDefaultState = function getDefaultState() {
  var _ref;

  return _ref = {}, (0, _defineProperty2.default)(_ref, LIST, {
    data: [],
    state: _constants2.STATES.NORMAL
  }), (0, _defineProperty2.default)(_ref, CREATE_USER, {
    data: initialCreateUserState,
    state: _constants2.STATES.NORMAL
  }), (0, _defineProperty2.default)(_ref, UPDATE_USER, {
    data: initialUpdateUserState,
    state: _constants2.STATES.NORMAL
  }), (0, _defineProperty2.default)(_ref, CHANGE_PASSWORD, {
    data: initialChangePasswordState,
    state: _constants2.STATES.NORMAL
  }), (0, _defineProperty2.default)(_ref, VIEW_USER, {
    data: initialUserState,
    state: _constants2.STATES.NORMAL
  }), (0, _defineProperty2.default)(_ref, "listConfig", {
    pageSize: 10,
    pageNumber: 1,
    totalCount: 0
  }), _ref;
};

var getInitialParams = function getInitialParams(state) {
  switch (state) {
    case UPDATE_USER:
      return initialUpdateUserState;

    case CHANGE_PASSWORD:
      return initialChangePasswordState;

    default:
      return initialCreateUserState;
  }
};

var usersReducer = function usersReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getDefaultState();
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var payload = action.payload,
      type = action.type;

  switch (type) {
    case _actions.SET_USERS:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          list: _objectSpread(_objectSpread({}, state.list), {}, {
            data: payload.users
          })
        });
      }

    case _actions.CHANGE_USER_PARAMS:
      {
        var key = payload.key,
            attribute = payload.attribute,
            value = payload.value;
        return _objectSpread(_objectSpread({}, state), {}, (0, _defineProperty2.default)({}, key, _objectSpread(_objectSpread({}, state[key]), {}, {
          data: _objectSpread(_objectSpread({}, state[key].data), {}, (0, _defineProperty2.default)({}, attribute, value))
        })));
      }

    case _actions.CLEAR_USER_PARAMS:
      {
        var _key = payload.key;
        return _objectSpread(_objectSpread({}, state), {}, (0, _defineProperty2.default)({}, _key, _objectSpread(_objectSpread({}, state[_key]), {}, {
          data: getInitialParams(_key)
        })));
      }

    case _actions.CHANGE_USER_STATE:
      {
        var _key2 = payload.key,
            newState = payload.state;
        return _objectSpread(_objectSpread({}, state), {}, (0, _defineProperty2.default)({}, _key2, _objectSpread(_objectSpread({}, state[_key2]), {}, {
          state: newState
        })));
      }

    case _actions.LOAD_USER_TO_UPDATE:
      return _objectSpread(_objectSpread({}, state), {}, (0, _defineProperty2.default)({}, UPDATE_USER, _objectSpread(_objectSpread({}, state[UPDATE_USER]), {}, {
        data: payload.user
      })));

    case _actions.LOAD_USER_ID_TO_CHANGE_PASSWORD:
      {
        return _objectSpread(_objectSpread({}, state), {}, (0, _defineProperty2.default)({}, CHANGE_PASSWORD, _objectSpread(_objectSpread({}, state[CHANGE_PASSWORD]), {}, {
          data: _objectSpread(_objectSpread({}, initialChangePasswordState), {}, {
            id: payload.id
          })
        })));
      }

    case _actions.LOAD_USER_TO_VIEW:
      return _objectSpread(_objectSpread({}, state), {}, (0, _defineProperty2.default)({}, VIEW_USER, _objectSpread(_objectSpread({}, state[VIEW_USER]), {}, {
        data: payload.user
      })));

    case _actions.CHANGE_USER_LIST_CONFIG:
      return _objectSpread(_objectSpread({}, state), {}, {
        listConfig: _objectSpread(_objectSpread({}, state.listConfig), payload.config)
      });

    default:
      return state;
  }
};

exports.usersReducer = usersReducer;
//# sourceMappingURL=users-reducer.js.map